@if (isLoaded && render) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
<bp-toast></bp-toast>
